import { TrashIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import RiyalSymbol from '../../assets/svg/RiyalSymbol';

interface ProductCardProps {
  data: any;
  logo: string;
  handleIncrement: (id: number) => void;
  handleDecrement: (id: number) => void;
  handleRemove: (id: number) => void;
}

export default function ProductCard({
  data, logo, handleDecrement, handleIncrement, handleRemove,
}: ProductCardProps) {
  const { t } = useTranslation();
  const isUnavailable = !data.in_stock || !data.is_active;

  return (
    <li key={data.id} className={classNames('relative flex py-6', { 'opacity-50': isUnavailable })}>
      <div className='h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200 relative'>
        <img
          alt={data.name}
          src={logo}
          className='h-full w-full object-cover object-center'
        />
        {isUnavailable && (
          <div className='absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center rounded-md'>
            <span className='text-xs text-white bg-red-600 px-2 py-1 rounded'>
              {t('productDetails.availability.outOfStock')}
            </span>
          </div>
        )}
      </div>

      <div className='ltr:ml-4 rtl:mr-4 flex flex-1 flex-col'>
        <div>
          <div className='flex justify-between text-base font-medium'>
            <h3 className='flex-1'>
              <p className='block text-black'>{data.name}</p>
            </h3>
            <p className='ltr:ml-4 rtl:mr-4 text-primary whitespace-nowrap flex items-center' dir='ltr'>
              <RiyalSymbol color='currentColor' width={14} height={14} />
              <span>{data.total_price || data.price}</span>
            </p>
          </div>
        </div>

        <div className='flex flex-1 items-end justify-between text-sm'>
          <div className='flex items-center'>
            <p className='text-secondary'>
              {t('productDetails.productInfo.quantity')}
              :
            </p>
            <button
              type='button'
              onClick={() => handleDecrement(data.id)}
              className='px-2 border rounded text-secondary hover:bg-primary hover:text-white ltr:ml-2 rtl:mr-2'
              disabled={isUnavailable}
            >
              -
            </button>
            <span className='px-2'>{data.quantity}</span>
            <button
              type='button'
              onClick={() => handleIncrement(data.id)}
              className='px-2 border rounded text-secondary hover:bg-primary hover:text-white'
              disabled={isUnavailable}
            >
              +
            </button>
          </div>

          <div>
            <button
              type='button'
              onClick={() => handleRemove(data.id)}
              className='flex items-center justify-center bg-red-50 p-2 rounded'
            >
              <span className='sr-only'>Remove</span>
              <TrashIcon aria-hidden='true' className='h-4 w-4 text-red-600' />
            </button>
          </div>
        </div>
      </div>
    </li>
  );
}
